import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PopupLoginComponent } from 'src/app/components/modals/popup-login/popup-login.component';
import { PopupRealTimeBiddingComponent } from 'src/app/components/modals/popup-real-time-bidding/popup-real-time-bidding.component';
import { IAnimal } from 'src/app/models/animal';
import { IAuctionBid, IOpenedSchedule } from 'src/app/models/transactions';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-online-bid-action',
  templateUrl: './online-bid-action.component.html',
  styleUrls: ['./online-bid-action.component.scss'],
})
export class OnlineBidActionComponent implements OnInit {
  constructor(private storage: StorageService, private dialog: MatDialog) {}

  @Input() animal_obj: IAnimal = {} as IAnimal;
  @Input() auction_bid: IAuctionBid = {} as IAuctionBid;
  @Input() opened_schedule: IOpenedSchedule = {} as IOpenedSchedule;

  @Input() is_live: 'LIVE' | 'DETAILS' = 'LIVE';
  @Input() bid_status: 'FINISH' | 'REAL_TIME' | 'OPEN' | 'CLOSED' = 'OPEN';
  @Input() next_bid: any = 0;
  @Input() increment: any = 0;
  @Input() list_bids: any = [];
  @Input() attual_bid = 0;
  @Input() isStatus: 'ACEITO' | 'SUPERADO' | 'RECUSADO' |  'AGUARDANDO'  | '' = '';
  @Output() eventSocket = new EventEmitter<any>();

  analizing_bid = false;
  outbid = false;

  is_login = false;

  timer: number = 3 * 60 * 1000; // 3 minutos
  timerStartCheck: any = 20 * 60 * 1000; // 20 minutos
  timerToEnd: any = 0;

  time = { days: 0, hour: 0, min: 0, seg: 0 };
  user = this.storage.myself;


  ngOnInit() {
    console.log('---------AOVIVO---------');

    this.analizing_bid = this.isStatus  === 'AGUARDANDO';
    this.outbid = ['RECUSADO', 'SUPERADO'].includes(this.isStatus);

    clearInterval(this.timerToEnd);

    if (this.storage.token && this.storage.token !== '') {
      this.is_login = true;
    }

    if (this.attual_bid <= 0) {
      this.attual_bid = this.animal_obj.bid;
    }

    // this.getListBid();
    this.next_bid = this.next_bid || this.animal_obj?.bid;
    // this.timer = this.opened_schedule.time_bid * 60 * 1000;

    // this.analizing_bid = true;

    this.timerToEndAuction();
    this.timerToEnd = setInterval(() => {
      this.timerToEndAuction();
    }, 1000);
  }

  public get startBid(){
    return new Date(this.animal_obj.start_bid) <= new Date();
  }

  timerToEndAuction() {
    const now = new Date();

    // Se ainda não começou, calcular tempo até o início
    if (!this.startBid) {
      const startDate = new Date(this.animal_obj.start_bid);
      const diffStart = startDate.getTime() - now.getTime();

      if (diffStart > 0) {
        const secondsStart = Math.floor(diffStart / 1000);
        this.time.min = Math.floor(secondsStart / 60);
        this.time.seg = secondsStart % 60;
        this.bid_status = 'CLOSED'; // Antes de começar
        this.analizing_bid = false;
        return;
      }
    }

    // Se já começou, calcular tempo até o fim
    if (['OPEN', 'REAL_TIME', 'CLOSED'].includes(this.bid_status) || this.startBid) {
      let finalDate = new Date(this.opened_schedule.finish_date);

      const newFinal = new Date(this.animal_obj.start_bid);
      newFinal.setMinutes(newFinal.getMinutes() + this.opened_schedule.time_bid);

      // Se a data final for anterior ao último lance, ajuste para o último lance
      if (new Date(this.opened_schedule.finish_date) < new Date(newFinal)) {
        finalDate = new Date(newFinal);
      }

      // Calcular a diferença entre o momento atual e a hora final
      const diff = finalDate.getTime() - now.getTime();

      // Calcular o tempo restante em segundos
      const value = Math.floor(diff / 1000);
      const minutes = Math.floor(value / 60);
      const seconds = value % 60;

      this.time.min = Math.trunc(minutes); // Diff em minutos
      this.time.seg = Math.trunc(seconds); // Diff em segundos

      if (this.time.seg <= 0 && this.time.min <= 0) {
        this.bid_status = 'FINISH';
        this.animal_obj.status = 'VENDIDO';
        clearInterval(this.timerToEnd);
        // this.eventSocket.emit(true);
      } else {
        if (diff > 0 && diff < this.timer) {
          this.bid_status = 'REAL_TIME';
        } else {
          this.bid_status = 'OPEN';
        }
      }

      this.analizing_bid = false;
    }
  }

  openOnlineBidPopup() {
    if (!this.storage.token || this.storage.token === '') {
      this.openPopuplogIn();
      return;
    }

    const dialogRef = this.dialog.open(PopupRealTimeBiddingComponent, {
      width: '90%',
      maxWidth: '500px',
      disableClose: true,
      data: {
        id: this.auction_bid?.id,
        animal: this.animal_obj,
        increment: this.increment,
        auction_bid: this.auction_bid,
        attual_bid: (this.attual_bid || 0) + this.increment,
        next_bid: this.next_bid,
        max_bid: this.attual_bid * (this.attual_bid < 100 ? 3.5 : 1.5),
        enableBid: true,
        timer: null,
        type: 'AOVIVO',
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result.action === 'yes') {
        this.eventSocket.emit(true);
      }
    });
  }

  openPopuplogIn() {
    const popupLoginRef = this.dialog.open(PopupLoginComponent, {
      width: '90%',
      maxWidth: '400px',
    });
    popupLoginRef.afterClosed().subscribe((result: any) => {
      if (result.action === 'yes') {
        this.eventSocket.emit(false);
      }
    });
  }
}
